import React, { Component, PropTypes } from 'react';
import './Flareon.scss';

class Flareon extends Component {
  render() {
    return (
      <div className="pokemon">
        <div className="flareon">
          <div className="head">

          </div>
          <div className="body">

          </div>
        </div>
      </div>
    );
  }
}

export default Flareon;



/** WEBPACK FOOTER **
 ** ./source/136-flareon/Flareon.js
 **/